import * as React from 'react';
import Home from '../components/Home';
import Stories from '../components/Stories';

const Index = () => {
    return <>
        <Home />
        <Stories />
    </>
};

export default Index